import { AxiosRequestConfig } from 'axios'
import { apiService } from '../../api-base'
import {
  CreateTicketMessagePayload,
  CreateTicketMessageResponse,
  CreateTicketPayload,
  CreateTicketResponse,
  TicketDetailsResponse,
  TicketUnreadUpdatesResponse,
  TicketsResponse,
  UpdateTicketPayload,
  UpdateTicketResponse,
} from './types'

export class TicketsService {
  static getTickets(config?: AxiosRequestConfig) {
    return apiService.get<TicketsResponse>('/tickets', config)
  }

  static getTicketById(id: string, config?: AxiosRequestConfig) {
    return apiService.get<TicketDetailsResponse>(`/tickets/${id}`, config)
  }

  static getUnreadUpdates(config?: AxiosRequestConfig) {
    return apiService.get<TicketUnreadUpdatesResponse>(
      '/tickets/unread-updates',
      config,
    )
  }

  static markUnreadUpdatesRead(ticketId: string, config?: AxiosRequestConfig) {
    return apiService.post<TicketUnreadUpdatesResponse>(
      `/tickets/${ticketId}/unread-updates/read`,
      undefined,
      config,
    )
  }

  static createTicket(data: CreateTicketPayload) {
    return apiService.post<CreateTicketResponse>('/tickets', data)
  }

  static createTicketMessage(
    ticketId: string,
    data: CreateTicketMessagePayload,
  ) {
    return apiService.post<CreateTicketMessageResponse>(
      `/tickets/${ticketId}/messages`,
      data,
    )
  }

  static updateTicket(ticketId: string, data: UpdateTicketPayload) {
    return apiService.patch<UpdateTicketResponse>(`/tickets/${ticketId}`, data)
  }
}
